import { render, staticRenderFns } from "./MatchDetailDemoScene.vue?vue&type=template&id=668ab02b&"
import script from "./MatchDetailDemoScene.vue?vue&type=script&lang=js&"
export * from "./MatchDetailDemoScene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports